import { Navigate, type RouteObject } from 'react-router';
import { ReferenceDataPage } from './pages/ReferenceDataPage';
import { REFERENCE_DATA_TABS, referenceDataTabPath } from './reference-data.paths';

export const REFERENCE_DATA_ROUTES: RouteObject[] = [
  { path: 'reference-data', element: <Navigate to={referenceDataTabPath(REFERENCE_DATA_TABS[0])} replace /> },
  ...REFERENCE_DATA_TABS.map((tab) => ({ path: `reference-data/${tab}`, element: <ReferenceDataPage tab={tab} /> })),
];
